import clsx from 'clsx';
import { useAccountSelectStore, useCurrentCardStore, useSidebarStore } from '@lib/store';
import { useResponsive } from '@shared/hooks';
import { PaletteUtils } from '@shared/utils';
import { CloseIcon, DropDownIcon } from '@shared/widgets';

interface HeaderProps {
  className?: string;
  name: string;
}

export const Header = (props: HeaderProps) => {
  const currentCardStore = useCurrentCardStore();
  const sidebarStore = useSidebarStore();
  const accountSelectStore = useAccountSelectStore();

  const { isSmallScreen } = useResponsive();

  return (
    <div
      className={clsx(
        'cursor-pointer flex justify-between items-center align-center mt-5 mx-0 mb-6',
        !PaletteUtils.isBordierPalette && 'group',
        props.className,
      )}
      onClick={accountSelectStore.toggleAccountsSelect}
    >
      {isSmallScreen && (
        <CloseIcon
          className={'-mt-[-20px] mr-[10px] ml-0 mb-0 hover:text-[#dc291c]'}
          onClick={(e) => {
            e.stopPropagation();
            currentCardStore.hideAllPanels();
            sidebarStore.toggleSidebar();
          }}
        />
      )}
      <div className={clsx('text-[#4c4c52] text-xl tracking-[0.1px] uppercase', PaletteUtils.isBordierPalette ? 'text-[#4c4c52]' : 'text-[#e5c496]')}>
        {props.name}
      </div>
      <DropDownIcon className={clsx('flex', !PaletteUtils.isBordierPalette && 'group-hover:text-[#e5c496]')} isOpen={accountSelectStore.data} />
    </div>
  );
};
